import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIndexPath = returnPath("/admin/departments");
export const getIdPath = returnPath("/admin/departments/:id");
